import { render } from "./StudentFinalScreen.vue?vue&type=template&id=79e0280e&ts=true"
import script from "./StudentFinalScreen.vue?vue&type=script&lang=ts"
export * from "./StudentFinalScreen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__